export function changeByTrimmedRange(state, changes) {
  return state.changeByRange(range => changes(trimmedRange(state, range)))
}

export function trimmedRangeText(text, {from, to}) {
  if (text.trim() === '') {
    return {from, to: from};
  }
  return {
    from: from + (text.length - text.trimStart().length),
    to: to - (text.length - text.trimEnd().length)
  };
}

export function trimmedRange(state, {from, to}) {
  return trimmedRangeText(state.sliceDoc(from, to), {from, to});
}
